function NRNPMIcon({ height = '20', width = '20' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.531 2H3.46897C2.65768 2 2 2.65768 2 3.46897V20.531C2 21.3423 2.65768 22 3.46897 22H20.531C21.3423 22 22 21.3423 22 20.531V3.46897C22 2.65768 21.3423 2 20.531 2Z"
        fill="#CD0000"
      />
      <path d="M6 17.9924H12L12.0076 9.00763H15L14.9924 18H17.9924L18 6.01527L6.01527 6L6 17.9924Z" fill="white" />
    </svg>
  );
}
export default NRNPMIcon;
